export default {
  title: 'FII Industrial Internet',
  menu: {
    homePage: 'HomePage',
    user: 'Personal Center',
    logout: 'Logout',
    Management_by_objectives: 'Management by objectives',
    reduceManagement: 'Reduce Management',
    controlAndSchedulingManagement: 'Control and Scheduling Management',
    controlAndSchedulingGoalsAndAchievement: 'Control and Scheduling Goals and Achievement',
    renewableEnergy: 'Replace renewable energy usage',
    projectEmissionReduction: 'Project Emission Reduction',
    projectEmissionReductionProgressControl: 'Project progress control',
    basicModule: 'Basic module',
    organizationalStructure: 'Organizational structure',
    projectListEnvironmentalProtectionAndEnergyConservation:
      'Project List Environmental Protection and Energy Conservation Project System',
    carbonInventoryProject: 'Carbon Inventory Project',
    carbonInventoryTask: 'Carbon Inventory Task',
    certificationReportManagement: 'Certification Report Management',
    overviewOfProjectStatus: 'Project Status Overview',
    overviewOfProjectInvestment: 'Project Investment Overview',
    analysisOfReduceAchievements: 'Reduce Achievement Analysis',
    Goal_Achievement_Status: ' Achievement of emission control targets',
    Management_by_objectives_children: {
      Goal_setting_and_decomposition: 'Goal setting and decomposition',
      Absolute_control_and_scheduling_objectives_and_achievement: 'Control and scheduling objectives and achievement',
      Project_objectives_and_achievement: 'Project objectives and achievement',
      Project_emission_reduction_progress_control: 'Project emission reduction progress control',
      Project_emission_reduction_Goal: 'Project emission reduction goal',
      reduce_goal: 'Reduce goal',
      // Absolute_control_Goal: 'Absolute control goal',
      Absolute_control_Goal: 'Control goal',
      control_Goal: 'Control goal',
      Reduce_Goal_Achievement_Status: 'Reduce Goal Achievement Status',
    },

    operate: 'Operate',
    operate_children: {
      Carbon_butler: 'Carbon Assistant',
      foxconnProject: 'Project List -Foxconn Technology Group',
      Project_management: 'Project management',
      Project_management_children: {
        Project_list: 'Project list',
        Effect_evaluation: 'Effect evaluation',
      },
      organizational_management: 'Organizational management',
      account_management: 'Account management',
      Role_management: 'Role management',
      Menu_management: 'Menu management',
      carbon_butler: 'Carbon Assistant',
      carbon_butler_children: {
        Factor_maintenance: 'Emission Factor Settings',
        Exchange_rate_table: 'Exchange Rate Settings',
        inventory_Task: 'Inventory task',
        inventory_Project: 'Inventory project',
        approvalCenter: 'Approval center',
      },
    },
    workbench: 'Workbench',
    workbench_children: {
      To_do_list: 'To do list',
      History_notification: 'History notification',
    },
    // 碳管家
    CarbonInventory: 'Carbon inventory',
    inventoryProject: 'Inventory project',
    inventoryTask: 'Inventory task',
    Level1Nav: 'Primary navigation',
    Level2Nav: 'Secondary navigation',
    Level3Nav: 'Three-level navigation',
    AlarmLog: 'Message',
    reportDetail: 'Report details',
    backstage: 'Settings',
    personalCenter: 'Account',
    signOut: 'Log out',
    loginTitle: 'Login',
    login: 'Login',
    centerApproval: 'Approval center',
    carbonTemplate: 'Carbon inventory template',
    carbonTemplateReportInventory: 'Carbon inventory template report',
    certificate: 'ISO14064 Certificate Management',
  },
  button: {
    // Public buttons, placeholders, etc.
    allBtn: {
      search: 'search',
      screen: 'screen',
      reset: 'Reset',
      deleteAll: 'Batch deletion',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      more: 'More',
      confirm: 'OK',
      sure: 'Verify',
      cancel: 'Cancel',
      close: 'Off',
      query: 'Query',
      yes: 'is',
      no: 'no',
      set: 'Settings',
      uploadFile: 'Upload file',
      uploadAttachment: 'Upload attachment',
      fileUpload: 'File upload',
      clickUpload: 'Click to upload',
      exportReport: 'Export report',
      exportAttachment: 'Export attachment',
      back: 'Back',
      addNew: 'Add',
      submit: 'Submit',
      copy: 'copy',
      download: 'Download',
      upload: 'Upload',
      downloadTemplate: 'Download Template',
      import: 'Import',
      bindTemplate: 'binding template',
      uploadCertificate: 'Upload certificate',
      view: 'View',
    },
    // License button
    licenceBtn: {
      title: 'License List',
      addLicence: 'New licenses',
    },
    // 监测方式
    detectionMode: {
      title: 'Monitoring mode',
    },
  },
  components: {
    multipleYear: {
      selectYearPlaceholder: 'Please select a year',
      monthUnit: 'month',
      yearUnit: 'years',
    },
    fileUpload: {
      uploadTip: 'Please upload the file',
      uploadTip1: '1. Supported extensions: Supported',
      uploadTip2: 'Format',
      uploadTip3: 'The file size cannot exceed',
      formatNotSupport: 'File format not supported',
      deleteFileFail: 'Failed to delete the file, please try again',
      uploadFail: 'Failed to upload the file, please try again',
      supportType: 'Supported file types',
      clickUpload: 'Drop file here or click to upload',
      uploadTip4: 'Upload third-party certification certificate',
      uploadLimit: 'The number of uploaded files cannot exceed',
      title: 'Report name',
    },
  },
  // 证书管理
  certificate: {
    year: 'Year',
    org: 'Organization',
    accountingBu: 'Accounting BU',
    showDetail: 'View Details',
    share: 'Share',
    certDetail: 'Certificate Details',
    author: 'Owner',
    fileSize: 'File size',
    previewTip: 'This file format is not supported preview, only support download!',
    copySuccess: 'The link has been copied to the clipboard',
    copyFail: 'The browser does not support automatic copy to the clipboard',
  },
  // 登录页
  login: {
    fii_SmartCarbon: 'FII Smart Dual Carbon Management Platform',
    fii_SmartCarbon2: 'Smart Dual Carbon Management Platform',
    loop_economy: 'Circular economy',
    make_green_factory:
      'Collaborative efforts to reduce pollution and carbon emissions, enhance efficiency, and build a green lighthouse factory ',
    smart_energy: ' Digitally empowered ',
    zero_carbon: 'Deeply cultivating clean technology products to promote zero carbon in the entire value chain',
    welcome_login: 'Welcome to log in',
    account_info: 'Please enter account information',
    password: 'Please enter the password',
    login_btn: 'Login',
    please_input_account: 'Please enter your account!',
    please_input_password: 'Please enter the password!',
    network_error: 'Network exception, login failed!',
    get_organize_error: 'Failed to obtain organization permissions',
    tip: 'Copyright © 2022 Foxconn Industrial Internet Co.,Ltd.All rights reserved. Copyright © 2022 Foxconn Industrial Internet Co., LTD.All rights reserved. Guangdong ICP 17133408',
  },
  // 待办列表
  todo: {
    To_do_list: 'To-do List',
    All: 'All',
    Project_management: 'Projects',
    Carbon_butler: 'Carbon Assistant',
    Goal_setting_and_decomposition: 'Goals',
    Task: 'Task Name',
    Status: 'Status',
    CreateTime: 'Creation Time',
    CreateUser: 'Creator',
    Historical_Notifications: 'Notification History',
    My_Updates: 'My Updates',
    Completed: 'Completed',
    Overtime: 'Overdue',
    Common_Entrances: 'Common Entry Points',
    Manage: 'Show All',
    Platform_Dedirection: 'Go to',
    Smart_Dual_Carbon_Management_Platform: 'FII-Smart Dual Carbon Management Platform',
    Common_Entrance_Management: 'Common Entry Point Management',
    Beyond_Description: 'Remove the following applications before adding',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    To_do: 'To-do',
    In_Progress: 'In Progress',
    Delayed: 'Delayed',
    Notice: 'Notification',
    Time: 'Time',
    Project_objectives_and_achievement: 'Project Goals and Achievements',
    Project_List: 'Project List',
    Up_to_three_commonly_used_entrances: 'You can have a maximum of 3 common entry points.',
    Please_select_three_commonly_used_entrances: 'Please select three common entry points.',
    Update_Success: 'Update successful!',
  },
  homePage: {
    Our_Measures: 'Our Measures',
    Our_Investment_In_The_Project: 'Our Investment in Projects',
    Please_Select_The_Legal_Representative: 'Please select legal entity',
    Total_Baseline_Emissions: 'Baseline Emissions (tCO₂e)',
    Base_Year: 'Baseline Year',
    Year_2020: '2020',
    Range: 'Scope',
    Inventory_Carbon_Manager: 'No data available, please complete the inventory in Carbon Steward',
    Emission_Reduction_Path_In_The_Past_Five_Years: 'Our Five-Year Emission Reduction Path (tCO₂e)',
    Absolute_control_and_scheduling_objectives_and_achievement: 'Emission Control Targets and Achievements',
    Overview_of_emission_sources: 'Overview of Emission Sources',
    Absolute_emission_control_target_for_this_year: "This Year's Emission Control Target",
    Target_value: 'Target Value',
    Exceed: 'Exceeded',
    Accumulated_actual_emissions: 'Cumulative Actual Emissions',
    Annual_absolute_control_and_scheduling_goals: 'Annual Emission Control Target',
    Residue: 'Remaining',
    Scope_1: 'Scope 1',
    Scope_One: 'Scope 1',
    Scope_2: 'Scope 2',
    Scope_Two: 'Scope 2',
    Scope_3: 'Scope 3',
    Achievement_status_of_absolute_displacement_control_target: 'Achievement of Emission Control Targets',
    Overview_of_Carbon_Emissions: 'Carbon Emission Overview',
    year: 'Year',
    month: 'Month',
    Total_carbon_emissions: 'Total Carbon Emissions',
    Classification_of_emission_sources: 'Emission Source Categories (Scope 1, Scope 2)',
    Emission_source_list: 'Emission Source Ranking',
    Project_Overview: 'Project Overview',
    Organization: 'Organization',
    Planned_carbon_reduction: 'Planned Carbon Reduction',
    Annual_investment_amount: 'Annual Investment Amount',
    Ten_thousand_yuan: 'Ten Thousand Yuan',
    WanKwh: 'Ten Thousand kWh',
    License_Announcement: 'License Announcement',
    Two_licenses_expired: 'There are 2 licenses that have expired this year, please note to all responsible units!',
    Notification_Announcement: 'Notification Announcement',
    Risk_classification_control_and_hidden_danger_investigation_and_governance_system:
      'Risk Grading Control and Hidden Danger Investigation and Governance System',
    Notification_for_online_use: 'Notification of online usage',
    Annual_Task_Filling_Notice: 'Annual Task Filling Notice',
    Annual_Task_Filling_Notice_Description:
      'The task filling work for the year 2022 is underway. All units are requested to fill it out in a timely manner!',
    Annual_total_emissions: 'Annual Total Emissions',
    Annual_total_emissions2: 'Annual Total \n Emissions',
    Emissions: 'Emissions',
    Absolute_displacement_control: 'Emission Control',
    reality: 'Actual',
    target: 'Target',
    Accumulated_goals: 'Cumulative Target',
    Accumulated_actual: 'Cumulative Actual',
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
    steam: 'Steam',
    electric: 'Electricity',
    heat: 'Heat',
    Fixed_combustion: 'Stationary Combustion',
    Mobile_Burning: 'Mobile Combustion',
    Process_combustion: 'Process Combustion',
    Escaping_combustion: 'Fugitive Combustion',
    Request_exception: 'Request Exception',
    plan: 'Planning',
    FCE: 'Stationary Combustion Emissions',
    MCE: 'Mobile Combustion Emissions',
    //MCEF: 'Mobile combustion emissions fuel',
    //MCET: 'Mobile combustion emissions transportation',
    PD: 'Process Emissions',
    FE: 'Fugitive Emissions',
    OE: 'Purchased Energy',
    //EDR: 'Evacuation of refrigerant emissions',
    //TFDW: 'Fugitive discharge wastewater treatment',
    power: 'Purchased Electricity',
    vapour: 'Purchased Steam',
    thermalEnergy: 'Purchased Heat',
    refrigeration: 'Purchased Refrigeration',
  },
  userInfo: {
    Affiliated_organization: 'Organization',
    user_name: 'Username',
    account: 'Account',
    password: 'Password',
    Please_enter_your_old_password: 'Please enter the old password',
    Please_enter_your_new_password: 'Please enter the new password',
    Confirm_modifications: 'Confirm modification',
    Change_password: 'Change password',
    role: 'Role',
    Modified_successfully: 'Password modified successfully!',
    Please_enter_new_password: 'Please enter the new password!',
  },
  organizational_management: {
    Organization_Name: 'Organization Name',
    Please_enter_the_organization_name: 'Please enter the organization name',
    Search: 'Search',
    Reset: 'Reset',
    Add_organization: 'New Organization',
    Batch_Delete: 'Delete',
    Edit: 'Edit',
    Delete: 'Delete',
    Modify_Organization: 'Edit Organization',
    Organizational_code: 'Organization Code',
    Superior_organization: 'Parent Organization',
    Park: 'Park',
    Notes: 'Notes',
    Delete_Organization: 'Delete Organization',
    Confirm_to_delete_the_organization: 'Are you sure you want to delete this organization?',
    Confirm_batch_deletion_of_this_organization: 'Are you sure you want to batch delete these organizations?',
    The_organization_name_cannot_have_special_characters:
      'The organization name cannot contain special characters <&"><=>=<>',
    Organization_Name_Format: 'Please enter the organization name in the format of Business Group-TSBG',
    Business_group_park_legal_person_BU_building: 'Business Group, Park, Company, BU Building',
    Please_enter_the_organization_code: 'Please enter the organization code',
    Organization_name_format_no_uppercase_letters:
      'Please enter the organization name in the format of bg-tsbg and do not use uppercase letters',
    Please_select_an_organization: 'Please select an organization',
    Order_number: 'Number',
    Operate: 'Actions',
    Add_successful: 'Add successful',
    Edit_successful: 'Edit successful',
    Edit_failed: 'Edit failed',
    Add_failed: 'Add failed',
  },
  menu_management: {
    menu_name: 'Menu Name',
    Please_enter_the_menu_name: 'Please enter the menu name',
    Select_application: 'Select Application',
    Please_select_application: 'Please select an application',
    Add_menu: 'Add Menu',
    Directory: 'Directory',
    Menu: 'Menu',
    Button: 'Button',
    Edit_menu: 'Modify Menu',
    Delete_menu: 'Delete Menu',
    Confirm_to_delete_the_menu: 'Are you sure you want to delete this menu?',
    Add_successful: 'Added successfully',
    Edit_successful: 'Edited successfully',
    Delete_successful: 'Deleted successfully',
    Edit_failed: 'Edit failed',
    Add_failed: 'Add failed',
    Delete_failed: 'Delete failed',
    Menu_type: 'Menu Type',
    component: 'Component',
    Routing_address: 'Route Address',
    Sort: 'Sort',
    Menu_name: 'Menu Name',
    Menu_number: 'Menu Code',
    Application: 'Belongs to Application',
    Please_select_the_application_category: 'Please select an application category',
    Menu_hierarchy: 'Menu Hierarchy',
    Parent_menu: 'Parent Menu',
    Please_select_the_parent_menu: 'Please select a parent menu',
    Opening_method: 'Open Method',
    Inner_chain: 'Internal Link',
    Outer_chain: 'External Link',
    Nothing: 'None',
    Redirect: 'Redirect',
    open_the_homepage_and_load_the_menu: 'If you want to open the homepage and load the menu under this directory,',
    Please_fill_in_the_loading_menu_route: 'please fill in the menu route to be loaded,',
    After_setting: 'setting it as the homepage will replace other homepage settings',
    Front_end_components: 'Frontend Component',
    Vue_component: 'Frontend Vue component in the views folder path',
    Example: 'Example',
    The_URL_displayed_by_the_browser: 'URL displayed in the browser',
    The_corresponding_open_page: 'The corresponding page to open is the menu page',
    Permission_identification: 'Permission Identifier',
    Weight: 'Weight',
    System_weight: 'System Weight',
    Visible: 'Visibility',
    Yes: 'Yes',
    No: 'No',
    Please_enter_the_menu_number: 'Please enter the menu code',
    Please_select_the_application: 'Please select the application it belongs to',
    Please_select_the_menu_level: 'Please select the menu hierarchy',
    Please_input_frontend_components: 'Please enter the frontend component',
    Please_input_the_routing_address: 'Please enter the route address',
    Please_input_the_permission_identification: 'Please enter the permission identifier',
    Please_select_the_weight: 'Please select the weight',
    Please_select_the_opening_method: 'Please select the open method',
    Top: 'Top-level',
    Menu_can_be_assigned_to_any_role: 'The menu can be assigned to any role,',
    Business_weight: 'Business Weight',
    Menu_visibility: 'The menu is not visible to super administrators',
    When_the_menu_is_selected_to_be_the_homepage:
      'If you have selected the option to open as an internal or external link,',
    Please_fill_in_the_link: 'enter the link address to be opened here.',
  },
  // 运营  -- 角色管理
  role_management: {
    Role_name: 'Role Name',
    Please_enter_the_role_name: 'Please enter the role name',
    Role_number: 'Role Code',
    Please_enter_the_role_number: 'Please enter the role code',
    Add_role: 'Add Role',
    Edit_role: 'Edit Role',
    Delete_role: 'Delete Role',
    More: 'More',
    Authorization_menu: 'Authorize Menu',
    Authorization_data: 'Authorize Data',
    Confirm_to_delete_the_role: 'Are you sure you want to delete this role?',
    Menu_authority: 'Menu Permissions',
    Authorization_scope: 'Authorization Scope',
    Please_select_authorization_scope: 'Please select the authorization scope',
    Select_organization: 'Select Organization',
    Index: 'Number',
    Add_successful: 'Added successfully',
    Edit_successful: 'Edited successfully',
    Edit_failed: 'Edit failed',
    Add_failed: 'Add failed',
    Delete_successful: 'Deleted successfully',
    Delete_failed: 'Delete failed',
    Authorization_successful: 'Authorization successful',
    Authorization_failed: 'Authorization failed',
  },
  // 运营 --账号管理
  account_management: {
    normal: 'Normal',
    Deactivate: 'Deactivate',
    Keyword: 'Keywords',
    Please_enter_the_keyword: 'Please enter name, account, or phone number',
    Status: 'Status',
    Please_select_the_status: 'Please select status',
    Search: 'Search',
    Reset: 'Reset',
    Add_user: 'Add User',
    Batch_Delete: 'Delete',
    Edit: 'Edit',
    More: 'More',
    Reset_password: 'Reset Password',
    Authorization_role: 'Authorize Roles',
    Authorization_data: 'Authorize Data',
    Delete: 'Delete',
    Modify_user: 'Edit User',
    Job_number: 'Employee ID',
    User_name: 'Name',
    Password: 'Password',
    Re_password: 'Repeat Password',
    Organization: 'Organization',
    Organization_name: 'Organization Name',
    Position: 'Position information',
    // Please_select_the_position: 'Please select position information',
    Email: 'Email',
    Phone: 'Phone Number',
    Telephone: 'Telephone',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    Delete_user: 'Delete User',
    Confirm_to_delete_the_user: 'Are you sure you want to delete this user?',
    Confirm_batch_deletion_of_users: 'Are you sure you want to batch delete these users?',
    Select_organization: 'Select Organization',
    Please_enter_the_password: 'Please enter password',
    Password_format: 'Password must contain letters, special characters, uppercase and lowercase, 8-14 characters',
    Please_enter_the_password_again: 'Please enter password again',
    The_two_passwords_are_inconsistent: 'Password does not match the initial password',
    Please_enter_the_email: 'Please enter email',
    Email_format_error: 'Email format is incorrect',
    Please_enter_the_phone: 'Please enter phone number',
    Phone_format_error: 'Phone number format is incorrect',
    Please_enter_the_name: 'Please enter name',
    Please_enter_the_job_number: 'Please enter employee ID',
    Please_select_the_organization: 'Please select organization',
    Please_select_the_position: 'Please select position',
    Index: 'Number',
    Landline: 'Landline',
    Operation: 'Action',
    Role_Name: 'Role Name',
    Unique_Code: 'Unique Code',
    Add_successful: 'Added successfully',
    Edit_successful: 'Edited successfully',
    Edit_failed: 'Edit failed',
    Add_failed: 'Add failed',
    Delete_successful: 'Deleted successfully',
    Delete_failed: 'Delete failed',
    Confirm_to_reset_the_password: 'Are you sure you want to reset the password for this account?',
    // Reset_password: 'Reset Password',
    Reset_successful: 'Reset successful',
    Reset_failed: 'Reset failed',
    Authorization_successful: 'Authorization successful',
    Authorization_failed: 'Authorization failed',
  },
  project_list: {
    Project_list: 'Project List',
    Project_name: 'Project Name',
    Please_enter_the_project_name: 'Enter project name',
    Enter_the_project_name: 'Please Enter project name',
    Search: 'Search',
    Empty: 'Clear',
    Business_group: 'Business Group',
    Please_select_business_group: 'Please select a business group',
    Park: 'Park',
    Please_select_the_park: 'Please select a park',
    Project_type: 'Project Type',
    Please_select_the_project_type: 'Please select a project type',
    Energy_saving_technology: 'Energy-saving Technology',
    Please_select_the_energy_saving_technology: 'Please select an energy-saving technology',
    Energy_saving_object: 'Energy-saving Object',
    Please_select_the_energy_saving_object: 'Please select an energy-saving object',
    Responsible_person: 'Responsible Person',
    Please_enter_the_responsible_person: 'Please enter the responsible person',
    Legal_person: 'Legal Entity',
    Please_select_the_legal_person: 'Please select a legal entity',
    Estimated_start_time: 'Estimated Start Time',
    Actual_start_time: 'Start Time',
    Estimated_end_time: 'Estimated End Time',
    Actual_end_time: 'End Time',
    New_project: 'Create Project',
    Supervisor_review: 'Supervisor Review',
    // Business_group: 'Business Group Review',
    Fii_audit: 'Fii Review',
    No_need_to_add_Fii_audit: 'No need to add Fii reviewers',
    Please_select_Fii: 'Please select Fii',
    View_status: 'View Status',
    Delete: 'Delete',
    Draft: 'Draft',
    Status_change: 'Status Change',
    Confirm: 'Confirm',
    Confirm_and_submit: 'Confirm and Submit for Review',
    From: 'From',
    To: 'To',
    Acceptance_time: 'Acceptance Time',
    Click_upload_attachment: 'Click to upload attachments',
    Opinion: 'Opinion',
    Please_enter_the_opinion: 'Please enter comments (if any)',
    Current_approval_status: 'Current Status',
    Reject: 'Reject',
    Pass: 'Approve',
    Basic_information: 'Basic Information',
    Originator: 'Initiator',
    Name: 'Name',
    Contact: 'Contact Information',
    Landline_or_phone: 'Landline/Mobile',
    Email: 'Email',
    Create_time: 'Creation Time',
    Energy_saving_status: 'Energy Use Status and Problem Description',
    Condition_and_description: 'Status and Description',
    Project_information: 'Project Information',
    Energy_type: 'Energy Type',
    Please_select_the_energy_type: 'Please select energy type',
    Energy_source: 'Technology Source',
    Please_select_the_energy_source: 'Please select technology source',
    Implementation_position: 'Implementation Location',
    Please_select_the_BU: 'Please select BU',
    Energy_saving_principle: 'Energy-saving Principles and Measures',
    Principles_and_Measures: 'Principles and Measures',
    Effect_evaluation: 'Effect Evaluation',
    Energy_saving_improvement_year: 'Energy Consumption Before Improvement/Year',
    Energy_saving_improvement: 'Energy Consumption Before Improvement',
    Energy_saving_improvement_after_year: 'Energy Consumption After Improvement/Year',
    Energy_saving_improvement_after: 'Energy Consumption After Improvement',
    Unit: 'Unit',
    Amount_of_energy_saving: 'Energy Saving Quantity',
    Automatic_calculation: 'Automatically calculated',
    Emission_factors: 'Emission Factor',
    Please_enter_the_emission_factor: 'Please enter emission factor in t',
    Annual_emission_reduction: 'Annual Carbon Reduction',
    Please_enter_the_annual_emission_reduction: 'Please enter planned carbon reduction',
    Investment: 'Investment Amount',
    Please_enter_the_investment: 'Please enter amount',
    Energy_price_local: 'Local Energy Unit Price',
    Energy_price: 'Energy Unit Price',
    Carbon_intensity: 'Carbon Reduction Cost-effectiveness',
    Automatic: 'Automatically generated',
    Annual_investment_effect: 'Annual Investment Benefits',
    Investment_return: 'Investment Payback Period',
    Benefit_analysis: 'Benefit Analysis',
    Review_nodes: 'Review Node',
    Please_select_the_supervisor: 'Please select supervisor for review',
    Business_group_review: 'Business Group Review',
    Please_select_the_business_group_review: 'Please select business group for review',
    Status: 'Status',
    Draft_status: 'Cannot upload project materials in draft status',
    Approval_opinion: 'Approval Comments',
    Cancel: 'Cancel',
    Save_draft: 'Save Draft',
    // Confirm: 'Confirm',
    Update: 'Update',
    Pass_examine: 'Approved',
    Electricity: 'Electricity',
    water: 'Water',
    Steam: 'Steam',
    Gas: 'Gas',
    Warm: 'Heat',
    Other: 'Other',
    Own_technology: 'Internal Technology',
    External_technology: 'External Technology',
    Project_approved: 'Approved for Project',
    Procurement_completed: 'Purchase Completed',
    Implementation_completed: 'Implementation Completed',
    Acceptance_completed: 'Acceptance Completed',
    Supervisor_review_completed: 'Supervisor Review Completed',
    Business_group_review_completed: 'Business Group Review Completed',
    Fii_review_completed: 'Fii Review Completed',
    Fii_conducted_first: 'Projects with economic benefits of >= 100,000 must be reviewed by Fii first!',
    Closing_items: 'Project Completion',
    submit_supervisor_review: 'Confirm submission for supervisor review?',
    Submit_for_review: 'Submit for Review',
    Success: 'Success!',
    Request_exception: 'Request Exception',
    Attachment_is_being_uploaded: 'Attachment uploading, please wait',
    Special_details: 'Project Details',
    Energy_consumption_before_improvement_cannot_be_empty: 'Energy consumption before improvement cannot be empty',
    Energy_consumption_before_improvement:
      'Energy consumption before improvement cannot be less than energy consumption after improvement',
    Energy_consumption_after_improvement_cannot_be_empty: 'Energy consumption after improvement cannot be empty',
    Energy_consumption_after_improvement:
      'Energy consumption after improvement cannot be greater than energy consumption before improvement',
    The_initiator_cannot_be_empty: 'Initiator cannot be empty',
    Contact_information_cannot_be_empty: 'Contact information cannot be empty',
    Email_cannot_be_empty: 'Email address cannot be empty',
    Business_group_cannot_be_empty: 'Business group cannot be empty',
    Park_cannot_be_empty: 'Park cannot be empty',
    Project_name_cannot_be_empty: 'Project name cannot be empty',
    Estimated_start_time_cannot_be_empty: 'Estimated start time cannot be empty',
    Estimated_end_time_cannot_be_empty: 'Estimated end time cannot be empty',
    Project_type_cannot_be_empty: 'Project type cannot be empty',
    Energy_saving_object_cannot_be_empty: 'Energy-saving object cannot be empty',
    Energy_saving_technology_cannot_be_empty: 'Energy-saving technology cannot be empty',
    Energy_type_cannot_be_empty: 'Energy type cannot be empty',
    Technical_source_cannot_be_empty: 'Technology source cannot be empty',
    Responsible_person_cannot_be_empty: 'Responsible person cannot be empty',
    Energy_saving_principle_and_measure: 'Energy-saving principles and measures cannot be empty',
    Annual_emission_reduction_cannot_be_empty: 'Annual carbon reduction cannot be empty',
    Emission_factor_cannot_be_empty: 'Emission factor cannot be empty',
    Investment_amount_cannot_be_empty: 'Investment amount cannot be empty',
    Benefit_analysis_cannot_be_empty: 'Benefit analysis cannot be empty',
    Supervisor_review_cannot_be_empty: 'Supervisor review cannot be empty',
    Business_group_review_cannot_be_empty: 'Business group review cannot be empty',
    Please_upload_the_project_proposal: 'Please upload project proposal!',
    Please_wait_for_loading: 'Loading, please wait!',
    Project_deleted: 'Project has been deleted',
    File_upload_successful: 'File uploaded successfully',
    File_upload_failed: 'File upload failed',
    Please_select_the_acceptance_time: 'Please select acceptance time',
    Project_status_changed_successfully: 'Project status changed successfully',
    Status_changing: 'Status changing, please wait',
    End_time_must_be_greater_than_start_time: 'End time cannot be earlier than start time!',
    Energy_price_local_cannot_be_empty: 'Local energy unit price cannot be empty',
    Prompt: 'Reminder',
    Compressed_files_not_support_preview: 'Compressed files cannot be previewed, only downloaded!',
    Doc_files_not_support_preview: 'Doc files cannot be previewed, only downloaded!',
    Project_approval: 'Initiation',
    Update_project_success: 'Project update successful!',
    Add_project_success: 'Project added successfully!',
    Confirm_delete: 'Confirm deletion',
    No_revert: 'Cannot be recovered once deleted.',
  },
  Project_emission_reduction_progress_control: {
    Start_date: 'Start Date',
    End_date: 'End Date',
    Select_date: 'Select Date',
    Measures: 'Our Measures',
    Overview: 'Project Overview',
    Organization: 'Organization',
    Planned_carbon_reduction: 'Planned Carbon Reduction',
    Special_project_emission_reduction_indicators: 'Project Emission Reduction Targets',
    Responsible_person: 'Responsible Person',
    Number_of_items: 'Project Items',
    Special_project: 'Projects',
    Number_of_planned_special_projects: 'Planned Project Quantity',
    Number_of_completed: 'Completed Quantity',
    Completion_progress: 'Completion Progress',
    Planned_carbon_reduction_unit: 'Planned Carbon Reduction (tCO₂e)',
    Actual_carbon_reduction_unit: 'Completed Carbon Reduction (tCO₂e)',
  },
  project_objective: {
    Our_Investment_In_The_Project: 'Our Investment in Projects',
    Annual_Investment_Amount: 'Annual Investment Amount',
    Acceptance_review_completed_project: 'Projects with Completed Acceptance Review',
    All_projects: 'All Projects',
    Completed_projects: 'Completed Projects',
    Project_energy_saving: 'Energy Saving Quantity in Approved Projects',
    Actual_energy_saving: 'Actual Energy Saving Quantity',
    Project_status: 'Project Status',
    Number_of_projects: 'Number of Projects',
    Energy_saving: 'Energy Saving Quantity',
    Monthly_target: 'Monthly Targets',
    Monthly_target2: 'Monthly Actual',
    Monthly_target3: 'Monthly Cumulative Target',
    Monthly_target4: 'Monthly Cumulative Actual',
    Plan: 'Planned',
    Actual: 'Completed',
    Project_Approval: 'Initiation',
    Procure: 'Procurement',
    Implementation: 'Implementation',
    Acceptance: 'Acceptance',
    Supervisor_review: 'Supervisor Review',
    Business_Group_Review: 'Business Group Review',
    Fii_Review: 'Fii Review',
    Closing: 'Project Closure',
    Apply: 'Applicant Initiate Application',
    Department: 'Department Supervisor Review',
    Department_Approval: 'Department Approval Supervisor',
    Park: 'Park and Business Group Energy Efficiency Officer Review',
    Park_Approval: 'Energy Saving and Emission Reduction Review Supervisor',
    Park_Manager: 'Energy Saving and Emission Reduction Approval Supervisor',
    Central_Energy_Saving: 'Central Energy Saving and Emission Reduction Undertaker',
    Central_Energy_Saving_Approval: 'Central Energy Saving and Emission Reduction Review Supervisor',
    Central_Energy_Saving_Manager: 'Central Energy Saving and Emission Reduction Approval',
    Project_Approval_Completed: 'Initiation Application Signed and Approved',
    Start: 'Initiate Acceptance Application',
    Central_Approval_Completed: 'Central Approval Supervisor Signed and Approved Acceptance',
  },
  Reduce_Goal_Achievement_Status: {
    All_parks: 'All parks',
    Please_select: 'Please Select',
    Export: 'Export',
    Achievement_Status_png: 'Achievement Chart',
    Achievement_Status_xls: 'Achievement Details',
    by_time: 'By Time',
    By_organization: 'By Organization',
    Reduce_Goal: 'Reduce Achievement Status',
    Actual_cumulative: 'Cumulative Actual',
    MonthlyRate: 'Monthly Achievement Rate',
    AnnualRate: 'Annual Achievement Rate',
    Target_cumulative: 'Cumulative Target',
    Annual_target_reduce: 'Annual Emission Reduction Target',
    Achievement: 'Achieved',
    Exceed: 'Exceeded',
    Energy_saving: 'Energy Saving Quantity',
    Energy_saving_one: 'Energy Saving Quantity',
    Energy_saving_two: ' ',
    Energy_saving_three: ' ',
    Achievement_rate: 'Achievement Rate',
    Achievement_rate_one: 'Achievement Rate',
    Achievement_rate_two: ' ',
    Achievement_rate_three: ' ',
    Annual_target: 'Annual Target',
  },
  Absolute_control_and_scheduling_objectives_and_achievement: {
    Absolute_control_this_year: 'Annual targets',
    Actual_cumulative: 'Cumulative actual emissions',
    Annual_target: 'Annual target',
    Achievement: 'Achievement of targets',
    View: 'View',
    time: 'Time',
    Park_name: 'Park name',
    Last_update: 'Last update time',
    Achievement_status: 'Achievement status of targets',
    Park_achievement_status: 'Targets and achievements of each park',
    Cumulative_absolute_control: 'Cumulative targets',
    Standard: 'Target status',
    Last_statistics_time: 'Last data sync time',
    Carbon_Butler: 'Carbon Assistant is currently updating!',
  },
  Absolute_control_Goal2: {
    satusDesc1: 'Reach the standard',
    satusDesc2: 'Not up to standard',
    satusDesc3: 'Data not reported',
    message1: 'Export data',
    message2: 'Select export content',
    message3: 'Export the current filter data',
    message4: 'Derived chart',
    message5: 'Control export target form',
    message6: 'Switch views',
    message7: 'Project initiation time',
    message8: 'Final audit time',
    message9: 'Phase',
    空调系统: 'Air Conditioning System',
    空压系统: 'Air Compression System',
    照明系统: 'Lighting',
    环保系统: 'Environmental Protection System',
    供暖系统: 'Heating System',
    供汽系统: 'Steam Supply System',
    生产系统: 'Production System',
    工业同分: 'Industrial Division',
    配电系统: 'Distribution System',
    管理系统: 'Management System',
    其他设备: 'Other Devices',
    电力交易: 'Electricity Trading',
    month: 'Month',
    metrics: 'Metrics',

  },
  Project_emission_reduction_Goal: {
    Confirm_to_delete: 'Are you sure you want to delete this data?',
    Set_time: 'Set time',
    Project_target: 'Project emission reduction target',
    Project_reduce: 'Project emission reduction',
    Distribute_target: 'Allocation target',
    Upload: ' Drag and drop files here or click to upload',
    Upload_one: 'Drag and drop files here or',
    Upload_two: ' click to upload',
    Support_extension: 'Supported file extensions',
    Uploading: 'Uploading',
    Save: 'Save',
    Submit: 'Submit',
    Add: 'Add',
    Business_group_not_less_than_Fii:
      'The sum of project emission reductions for the business group cannot be less than the project emission reduction for Fii',
    Park_not_less_than_Business_group:
      'The sum of project emission reductions for the park cannot be less than the project emission reduction for the business group',
    Please_fill: 'Please fill in the data completely',
    One_business_group_data: 'Please fill in at least one data for the business group',
    One_park_data: 'Please fill in at least one data for the park',
    Please_fill_Fii: 'Please fill in the data for Fii completely',
    Same_organization: 'Cannot set two emission reduction targets for the same organization',
    Confirm_synchronize_subordinates:
      'After confirmation, the data of the subordinate level will be updated synchronously',
    Confirm: 'Are you sure you want to submit?',
    Submitting: 'Confirm submission',
    Submit_success: 'Submission successful',
    Submit_failed: 'Submission failed',
    Save_draft: 'Saved as a draft',
    Save_failed: 'Save failed',
    Retain_one: 'Please keep at least one data',
    Decimal_point_cannot_exceed_11: 'Numeric values, including decimal points, should not exceed 11 digits',
    Sum_of_1R_2R_3R_cannot_exceed: 'The sum of Reduce, Replace, and Reslove should not exceed the total',
    Sum_of_1R_2R_3R_must_be_equal: 'The sum of Reduce, Replace, and Reslove should not exceed the total',
    Download: 'Download',
    No_data: 'No files uploaded for this year',
    Distributional_Goals: 'Allocation target',
    File_upload: 'File upload',
    Sum_of_monthly_reduction_must_be_greater:
      'The sum of monthly project emission reductions cannot be less than the annual project emission reduction',
  },
  Absolute_control_Goal: {
    Standard_year: 'Compared to the baseline year',
    Absolute_control: 'targets',
    Standard_year_reduction: 'Percentage reduction compared to the baseline year',
    Business_group_not_less_than_Fii:
      "The sum of Fii's targets cannot be less than the sum of the business group's targets!",
    No_data: 'Corresponding target data not found!',
    Confirm_to_delete:
      'After deleting this data, the data belonging to its subordinate organizations will also be deleted.',
    Park_not_less_than_Business_group:
      "The sum of the park's emissions control total cannot be greater than the sum of the business group's  targets!",
    Business_group_not_less_than_Park:
      "The sum of the business group's emissions control total cannot be less than the sum of the park's targets!",
    Not_found: 'Corresponding target not found!',
    All_month_not_less_than_Business_group:
      "The sum of emissions control total for all months cannot be greater than the sum of the business group's  targets!",
    Business_group_not_less_than_All_month:
      "The sum of the park's emissions control total cannot be less than the sum of the monthly targets!",
  },
  // 驾驶舱
  cockpit: {
    R1_Reduction: '1R Energy Conservation and Emission Reduction',
    R2_Renew: '2R Renewable Energy Replacement',
    R1_total: 'Annual emission reduction target of 1R',
    R2_total: 'Annual emission reduction target of 2R',
    Reach: 'Achieved',
    Not_achieved: 'Not achieved',
    Control_and_emission_control: 'targets',
    Reduction: ' Emission reduction ',
    Legal_person: 'Number of company',
    Carbon_panoramic: 'Carbon footprint',
    Annual_control_ranking_target: 'Annual targets',
    Target_completion_rate: 'Target achievement rate',
    Accumulated_control_of_business_groups: 'Cumulative target for the business group',
    Accumulated_control_of_parks: 'Cumulative target for legal entities',
    Monthly_reduction: 'Monthly project emission reduction status',
    Actual_energy_consumption: 'Actual energy savings ratio',
    Total_investment: 'Total investment amount',
    Total_volume: 'Total',
    Energy_consumption: 'Energy savings',
    Annual_reduction: 'Annual emission reduction target',
    Carbon_reduction: 'Carbon emissions reduction',
    Total_planning: 'Overall planning',
    Energy_saving_situation_of_business_groups: 'Energy savings for the business group',
    Park_energy_consumption: 'Cumulative emission reduction for legal entities',
    Monthly_control_ranking: 'Monthly emission control status',
    Range12_of_control: 'Emission control status for Scope 1 and Scope 2',
    Energy_saving_situation: 'Emission reduction status',
    Actual_cumulative_reduction: 'Actual cumulative in descending order',
    Target_cumulative_reduction: 'Exceeded achievement rate in descending order',
    Actual_cumulative: 'Actual cumulative quantity',
    Target_reduction_volume: 'Target carbon reduction quantity',
    Annual_control_ranking: 'Annual emission control total',
    Energy_saving: 'Total energy savings',
    Details: 'Details',
    Estimated_completion_time: 'Expected completion time',
    Achievement_rate_of_emission_reduction_targets: 'Emission reduction target achievement rate',
    Accumulated_target_total_amount: 'Cumulative target total',
    Accumulated_actual_total_amount: 'Cumulative actual total',
    Excess_Rate: 'Excess rate',
  },
  message: {
    addSuccess: 'New success',
    editSuccess: 'Edit successfully',
    addFail: 'Add failure',
    editFail: 'Edit failure',
    deleteSuccess: 'Successfully deleted',
    deleteFail: 'Deletion failure',
    submitSuccess: 'Submit successfully',
    fillSuccess: 'Fill in successfully',
    fillFail: 'Fill failure',
    copySuccess: 'Successful replication',
    saveSuccess: 'Save successfully',
    saveFail: 'Save failure',
    updateSuccess: 'Update successfully',
    uploadSuccess: 'Upload successfully',
    uploadFail: 'Upload failure',
    updateFail: 'Update failure',
    computeSuccess: 'Calculation successfully',
    computeFail: 'Calculation failure',
    submitFail: 'Commit failure',
    importSuccess: 'Import successful',
    exportSuccess: 'Export Success',
    exportFail: 'Export failure',
    downloadSuccess: 'Download Success',
    importFail: 'Import failed',
    paramsError: 'Parameter error',
    exporting: 'Exporting report......',
    downloading: 'Downloading',
  },
  // 碳管家
  common: {
    add: 'New',
    delete: 'Delete',
    view: 'View',
    edit: 'Edit',
    cancel: 'Cancel',
    close: 'Close',
    sure: 'Confirm',
    search: 'Search',
    submit: 'Submit',
    export: 'Export',
    org: 'Organization',
    generate: 'Publish',
    preview: 'Preview',
    addS: 'Successfully added！',
    addE: 'Failed to add!',
    editS: 'Successfully edited!',
    editE: 'Failed to edit!',
    deleteS: 'Successfully deleted!',
    deleteE: 'Failed to delete!',
    pSelect: 'Please select',
    pInput: 'Please input',
    submitS: 'Successfully submitted!',
    submitE: 'Failed to submit!',
    chinese: 'Chinese',
    english: 'English',
    update: 'Update',
    push: 'Push',
    withdraw: 'Withdraw',
    updateS: 'Successfully updated!',
    updateE: 'Failed to update!',
    pushS: 'Successfully pushed!',
    pushE: 'Failed to push!',
    withdrawS: 'Successfully withdrawed!',
    withdrawE: 'Failed to withdraw!',
    changeS: 'Successfully Modified!',
    changeE: 'Failed to Modify!',
    data: 'Data',
    template: 'Template',
    templateSelect: 'Select a template',
    save: 'Save',
    save_success: 'Save successfully',
    level1: 'Poor',
    level2: 'Fair',
    level3: 'Good',
    level4: 'Excellent',
    level5: 'Excellent +',
    loading: 'loading...',
    checkSelect: 'Please check contents',
    selectOrSearch: 'Please select/search for the emission factor that best matches',
    deleteConfirm: 'Are you sure to delete?',
    tip: 'Tip',
  },
  tip: {
    tip1: 'This parameter contains a maximum of 10 decimal places',
    tip2: 'The temperature of superheated steam is up to 600℃',
    tip3: 'The temperature of superheated steam can not be less than 0℃',
    tip4: 'The superheated steam has a maximum pressure of 30MPa',
    tip5: 'The pressure of superheated steam should not be less than 0.02MPa',
    tip6: 'The maximum temperature of saturated steam is 373.68℃',
    tip7: 'The temperature of saturated steam can not be less than or equal to 6.98℃',
  },
  three: {
    loading: 'loading',
    type1_title: 'Purchased goods and services',
    type1_title1: 'Category 1: Purchased goods and services',
    type1_title2: 'Emissions from the upstream production of products purchased by the company in the reporting year',
    type1_choose_question: 'What kind of data can you provide?',
    type1_mode1: 'Purchase amount',
    type1_message1:
      'Users can provide the actual quantity of purchased products and services, including but not limited to weight, quantity, volume, etc.',
    type1_mode2: 'Carbon emissions',
    type1_message2: 'Users can directly obtain the carbon emissions of some purchased products and services',
    type1_mode3: 'Amount of expenditure',
    type1_message3:
      'The user cannot provide the actual amount of the product or service purchased, nor the carbon emissions of the corresponding product or service, but can provide the amount and voucher of the corresponding product or service',
    number_quality: 'Activity Data',
    carbon_unit: 'Carbon Emissions (tCO₂e)',
    correct_level: 'Instrument correction grade',
    add_continue: 'New',
    upload_error: 'Upload failure',
    upload: 'Please upload the attachment.',
    type1_tip1: 'Please select the product type/emission factor provided by the supplier',
    type1_tip2: 'Please input quantity/weight',
    type1_tip3: 'Please select',
    type1_tip4: 'Please select a product type',
    type1_tip5: 'Please enter the total amount of emissions',
    type1_tip6: 'Please enter the expenditure amount',
    type1_tip7: 'Please enter the number',
    type2_title: 'Capital goods',
    type2_title1: 'Category2 : Capital goods',
    type2_title2:
      'Upstream emissions generated by the fixed assets (plants, land, equipment, vehicles, etc.) purchased by the company in the reporting year',
    type2_mode1: 'Expenditure amount',
    type2_message1: 'Users can provide the expenditure amounts and amount vouchers for purchasing various fixed assets',
    type2_tip1: 'Please select the type of fixed asset or emission factor provided by the supplier',
    type2_tip2: 'Please select the type of fixed asset',
    type3_title: 'Fuel- and energyrelated activities',
    type3_title1: 'Category3 : Fuel- and energyrelated activities',
    type3_title2:
      'Emissions from fuels and energy purchased and consumed by the company in the reporting year (parts not included in Scope 1 and Scope 2)',
    type3_mode1: 'Fuel/Heat/Electricity Consumption',
    type3_message1: 'Users can provide the purchase or consumption of fossil fuels, electricity, and heat',
    type3_tip1: 'Please input consumption',
    type4_title: 'Upstream transportation and distribution',
    type4_title1: 'Category4 : Upstream transportation and distribution',
    type4_title2:
      'Emissions caused by the transportation and distribution of the products purchased by the company from the first-tier suppliers to the company',
    type4_mode1: 'Fuel consumption',
    type4_message1:
      'Users can provide the type of fuel consumed during transportation and the corresponding fuel consumption (weight, volume, etc.)',
    type4_mode2: 'Transportation distance and load capacity',
    type4_message2:
      'Users cannot obtain fuel consumption data during transportation, but can provide data on load conditions, transportation distance, transportation methods, etc.',
    type4_mode3: 'Transportation expenses',
    type4_message3:
      'When it is impossible to provide detailed fuel consumption and transportation distance data during transportation due to difficulties in data acquisition, safety restrictions, etc., this part of the emissions can be estimated through transportation expenses.',
    type4_tip1: 'Please select transportation fuel type',
    type4_tip2: 'Please enter volume or weight',
    type4_tip3: 'Please select the transportation mode',
    type4_tip4: 'Please enter the value',
    type4_tip5: 'Please select the unit',
    transport_weight: 'Weight of transport',
    transport_distance: 'Distance of transportation',
    type5_title: 'Waste Generated in Operations',
    type5_title1: 'Category5 : Waste Generated in Operations',
    type5_title2:
      "The waste generated by the company's operational activities in the reporting year and the emissions generated by handing it over to a third party for processing",
    type5_mode1: 'Waste processing volume',
    type5_message1:
      'Users can provide information on each waste type (cardboard, waste, wastewater, etc.), weight, and treatment method (incineration, landfill, recycling, compost, etc.)',
    type5_mode2: 'Waste disposal expenditure',
    type5_message2:
      'If the user cannot obtain detailed information on waste disposal, but can provide the cost of waste disposal, this method can be used to calculate carbon emissions',
    type5_tip1: 'Please select the waste type or disposal method',
    type5_tip2: 'Please enter the weight of waste',
    type6_title: 'Business travel',
    type6_title1: 'Category6 :Business travel',
    type6_title2:
      'Carbon emissions generated by employees using third-party transportation, hotel accommodation, etc. when going out to conduct business',
    type6_mode1: 'Travel mode and distance',
    type6_message1:
      'Users can provide detailed data such as transportation mode, travel distance, number of travelers, etc.',
    type6_mode2: 'Hotel accommodation',
    type6_message2:
      'Users can provide hotel accommodation information for business trips, such as number of days of stay, number of rooms, number of people, etc.',
    type6_mode3: 'Transportation expenses',
    type6_message3:
      'If the user cannot provide detailed travel mode, travel distance and other information, but can obtain the cost of each travel mode, this method can be used to calculate the traffic emissions caused by business travel',
    numberEmployees: 'Number of employees',
    travelDistance: 'Travel distance',
    people: 'people',
    day: 'day',
    type6_tip1: 'Please select the travel type',
    type6_tip2: 'Please enter the average travel distance/person',
    type6_tip3: 'Please select the country of accommodation',
    type6_tip4: 'Please enter the length of stay',
    type6_tip5: 'Please enter the total travel distance of the employee',
    type7_title: 'Employee commuting',
    type7_title1: 'Category7 : Employee commuting',
    type7_title2: 'Emissions caused by employees commuting from home to work',
    type7_mode1: 'Commuting mode and distance',
    type7_message1: "Users can provide information such as employees' daily commuting methods and commuting distances",
    number_commuters: 'Number of employees',
    number_commuters_unit: 'Number of employees Unit',
    commute_distance: 'Distance to commute',
    work_day: 'workday',
    type7_tip1: 'commuting options',
    type7_tip2: 'Please enter days',
    type7_tip3: 'Average round-trip distance per person per day (not one-way)',
    type7_tip4: 'Please enter the total daily commuting distance of the employee',
    type8_title: 'Upstream Leased Assets',
    type8_title1: 'Category 8: Upstream leased assets',
    type8_title2:
      'Emissions from assets leased by the operating company during the reporting year (the portion not included in Scope 1 & 2)',
    type8_mode1: 'rental fee',
    type8_message1:
      'If the user cannot obtain the energy consumption during the operation of the leased asset, this part of the emissions can be calculated through the lease fee expenditure',
    type8_message2:
      'The user has independently conducted a carbon inventory and can provide emission data on relevant leased asset operations during the reporting period',
    type8_tip1: 'Please select the building type',
    type8_tip2: 'Please enter the rental payment',
    type9_title: 'Downstream transportation and distribution',
    type9_title1: 'Category 9: Downstream transportation and distribution',
    type9_title2:
      "Emissions generated by warehousing at the company's operating sites, and transporting, delivering, and distributing to end customers through vehicles and facilities that are not owned or controlled by the company (and not paid by the company)",
    type9_tip1: 'Please enter the weight of the goods',
    type9_tip2: 'Please enter the distance',
    type9_message1:
      'Users can directly obtain the carbon emissions generated during the downstream transportation of products',
    type10_title: 'Processing of sold products',
    type10_title1: 'Category 10: Processing of sold products',
    type10_title2:
      'Emissions generated by intermediate products produced by the company, sold to downstream, and further processed by customers/third parties',
    type10_message1:
      'Users can directly obtain the carbon emissions generated by the processing of the corresponding sold products from downstream companies',
    type11_title: 'Use of sold products',
    type11_title1: 'Category 11: Use of sold products',
    type11_title2: 'Emissions generated during the use of products and services sold by end consumers',
    type11_message1:
      'Users can directly obtain the carbon emissions generated by end consumers using corresponding products',
    type12_title: 'Final disposal of products sold',
    type12_title1: 'Category 12: Final disposal of products sold',
    type12_title2:
      'Emissions from the products sold by the company during the reporting year as waste disposal and treatment processes at the end of their life cycles',
    type12_message1:
      'Users can provide information on the amount of products sold as waste disposal at the end of their life cycle, treatment methods and so on',
    type12_message2:
      'Users can provide the emissions generated when the products they sell are scrapped and disposed of after the end of their life cycle',
    type12_tip1: 'Please select waste type and diversion method',
    type12_tip2: 'Total mass of sold products and packaging',
    type13_title: 'Upstream Leased Assets',
    type13_title1: 'Category 13: Upstream Leased Assets',
    type13_title2:
      'Emissions generated during the operation of assets owned by the company (as lessor) and leased to other entities during the reporting year (and not included in Scope 1&2)',
    type13_mode1: 'rental fee',
    type13_message1:
      'If the user cannot obtain the energy consumption of the leased asset during operation, this part of the emissions can be calculated through the lease fee',
    type13_mode2: 'Carbon emissions',
    type13_message2:
      'The user has independently conducted a carbon inventory and can provide emission data on relevant leased asset operations during the reporting period',
    type14_title: 'Franchises',
    type14_title1: 'Category 14: Franchises',
    type14_title2:
      'The franchisor shall collect Scope 1 and 2 emission data from the franchisee. Operational emissions of the franchise that are not included in Scope 1&2 (i.e., the Scope 1&2 emissions of the franchisee) are applicable to the franchisee. ',
    type14_mode1: 'Based on quantity',
    type14_message1:
      'Users can provide the energy usage of the franchisee, such as the purchased electricity, heat, fossil fuels, etc.',
    type14_mode2: 'Carbon emissions',
    type14_message2: 'Users can obtain carbon emissions directly from the franchisee',
    type14_tip1: 'Please select a rental asset',
    type15_title: 'Investments',
    type15_title1: 'Category 15: Investments',
    type15_title2:
      'This category is suitable for carbon emission calculations of corporate investments and other financial activities',
    type15_mode1: 'Carbon emissions',
    type15_message1:
      'If the enterprise invested by the user reports its own carbon emissions, the carbon emissions of this category can be estimated based on the equity investment ratio',
    type15_mode2: 'invested company revenue',
    type15_message2:
      'If the carbon emissions of the invested company cannot be provided, users can estimate the carbon emissions of this category based on the equity ratio through the revenue data of the invested company',
    equity_ratio: 'share of equity',
    type15_tip1: 'Maximum 100',
    equity_ratio_unit: 'share of equity (%) Unit',
    work_day_unit: 'day',
  },
  audit: {
    needComments: 'Please fill in the approval comments!',
    taskSubmit: 'TaskSubmit',
    auditStatus: 'Approval status',
    main: 'Subject of inventory',
    deadline: 'Deadline',
    submitTime: 'submit time',
    submitM: 'Submitter',
    approvalStatus: 'Approval status',
    approvalDeal: 'Approval deal',
    agree: 'Pass!',
    reject: 'Reject!',
    title: 'Determine and notify the approver',
    approvalMan: 'Approver',
    tip: 'Approval submitted! Return to the task list of carbon inventory in 3s',
    status2: 'Approval rejected',
    approvalProgress: 'Approval progress',
    approvalProgressError: 'Unavailable to non-project sponsors',
    viewApproval: 'View approval',
    viewProgress: 'View progress',
    taskApproval: 'Progress of task approval',
    validStatus: 'Valid status',
    historyNotice: 'Historical notices',
    seeMore: 'View more',
    noticeContent: 'Notice',
    noticeTime: 'Notice time',
    carbonInventoryProject: 'Carbon inventory project',
    projectOverview: 'Project overview',
    checkTime: 'Inventory time: ',
    deadlineTime: 'Deadline: ',
    totalNumberOfCommitted: 'Submitted in total: ',
    totalNumberOfApprovals: 'Total Number of Approvals: ',
    editCarbonInventory: 'Edit Carbon Inventory Project Information: ',
    errorInfo: 'Inventory subject cannot edit/submit/approve reports',
    wait: 'Pending',
    pending: 'Under Review',
    pass: 'Approved',
    rejected: 'rejected',
    taskStatus: 'Task Status',
    history: 'History',
    historyTip: 'Please select the task you want to view',
    approvalAdvice: 'Approval Comments',
    rejectTip: 'After rejection, it will be submitted to you for further approval',
    passWord: 'Approved',
    rejectWord: 'Please specify the reason for rejection',
    content0: 'Approval not submitted, please remind the reporter to submit',
    content1: 'Please wait for the approval result',
    content2: 'Approval completed, no further action required',
    content3: 'The approval has been rejected',
    errorMessage: 'Exceptional Status',
    approvalErrorMessage: 'Please provide approval comments!',
    mySubmit: 'I submitted it for approval',
    myWaited: 'Wait for my approval.',
    myHistory: 'Historical approval',
  },
  project: {
    annual: 'Annual inventory',
    monthly: 'Monthly inventory',
    special: 'Customer special inventory',
    business: 'Business group independent inspection',
    government: 'Government key control and arrangement of enterprises inventory',
    trading: 'Carbon trading related inventory',
    other: 'Other inventory',
    fillInput: 'Automatic calculation',
    deadLine: 'Deadline',
    inventoryDeadLine: 'Inventory Deadline',
  },
  table: {
    consolidation: 'Greenhouse gas emissions merging method',
    range: 'Scope',
    sort: 'No.',
    type: 'Type',
    factor: 'Emission Factors',
    unit: 'Unit',
    factorValue: 'Emission Factor Value',
    factorUnit: 'Emission Factor Unit',
    dischargeFacility: 'Facility',
    factorSource: 'Emission Factor Data Source',
    activeDataQ: 'Activity Data (Amount)',
    activeDataT: 'Activity Data (Temperature)',
    activeDataP: 'Activity Data (Pressure)',
    greenProject: 'Greenhouse Gas Reduction Project',
    certified: 'Units of Certified offsets',
    dischargeInventory: 'Emission Inventory',
    dioxideEquivalent: 'Data Information',
    total: 'Total Carbon Emission',
    factorValue1: 'Emission Factor Value',
    activeDataGrade: 'Activity Data Category (Score)',
    calibrationGrade: 'Calibration Category (Score)',
    gradingStandard: 'Grading Standard',
    level1: 'Level 1 (Poor)',
    level2: 'Level 2 (Fair)',
    level3: 'Level 3 (Good)',
    level4: 'Level 4 (Excellent)',
    level5: 'Level 5 (Excellent+)',
    emissionFactorName: 'Emissionunittyp Factor Name',
    emissionFactorValue: 'Emission Factor Value',
    emissionfactorGrade: 'Emission Factor Category (Score)',
    emissionfactorSource: 'Emission Factor Source',
    removalVolume: 'Reduction Units',
    activityAttachment: 'Activity Data Attachment',
    fileTip:
      'Clarification of greenhouse gas emission sources, criteria for significant indirect greenhouse gas emissions, Global Warming Potential (GWP) values used in calculations, and their sources.',
    file1: 'Attachment1.pdf',
    file2: 'Attachment2.pdf',
    score: 'Score',
    score1: 'Score <2.0',
    score2: '3.0 > Score ≥ 2.0',
    score3: '4.0 > Score ≥ 3.0',
    score4: '5.0 > Score ≥ 4.0',
    score5: 'Score ≥ 5.0',
    rangeTip1: 'Scope 1',
    rangeTip2: 'Scope 2',
    rangeTip3: 'Scope 3',
    rangeTip31: "Scope 3: Indirect Greenhouse Gas Emissions from Organization's Product/Service Use",
    rangeTip32: 'Scope 3: Indirect Greenhouse Gas Emissions from Product Use and Disposal',
    rangeTip33: 'Other Indirect Greenhouse Gas Emissions',
    domesticSewage: 'Domestic Sewage',
    industrialWastewater: 'Industrial Wastewater',
    refrigerant: 'Refrigerant',
    level: 'Level',
    name: 'name',
    jobNumber: 'job number',
    authority: 'authority',
    organization: 'organization',
  },
  symbol: {
    leftBracket: '（',
    rightBracket: '）',
  },
  task: {
    selected: 'selected',
    clear: 'clear',
    canSelectApprover: 'approval node that can be specified',
    'organization-direct': 'Organizational level - Supervisor',
    'organization-high': 'Organization level - Senior Manager',
    businessGroup: 'Business group level - Manager',
    CentralGroup: 'Group central level - Manager',
    'select-approver': 'Specify participants of subsequent approval nodes',
    searchNameOrCode: 'Search',
    selectOneApprover: 'Select Approver (single option)',
    selectApprover: 'Please select approver',
    noneTip: 'You have selected none, please cancel first!',
    none: 'None',
    involove: 'The task I participated in',
    start: 'The task I initiated',
    downloadFile: 'Download Attachment',
    projectApl: 'Project Approval',
    approval: 'If task approval is required, please check',
    projectMessge: 'Project Information',
    buttonTip: 'I confirm that the items not reported are not reported',
    tip: 'The information you filled in is as follows: blue is the completed item and grey is the unfinished item. Please check and confirm the content',
    greenReason: 'Please state the rationale for exempting the quantification of this GHG',
    importReason1:
      'Please specify the reasons, e.g. emissions are estimated to account for more than 10% of the total emissions of the ORGANIZATION',
    importReason2: 'Please specify the reasons, e.g. organization is quantified by raw data or stimulus data',
    importReason3:
      'Please specify the reasons, e.g. it does not involve core secrets of the company and related upstream and downstream parties',
    importReason4:
      'Please specify the reasons, e.g. indirect greenhouse gases designated by relevant parties and incorporated by laws and regulations',
    importReason5: 'Please specify other criteria',
    PSGreen: 'Please select the Greenhouse Gas Reduction Project',
    PDImport: 'Please define and explain important indirect emission standards',
    notSubmit: 'No report has been submitted',
    jpName: 'Name of legal person',
    countryOrArea: 'Country or region',
    addressRegistration: 'Address of registration',
    boundary: 'The boundaries of inventory',
    boundaryInput: 'Please enter the detailed information of the inspected factory or building or production line',
    factory: 'Factory',
    report: 'Report',
    title: 'GHG Inventory Accounting Task List',
    title1: 'GHG Inventory Accounting Project List',
    quickInventory: 'Quick Accouting',
    complianceInventory: 'Compliance Accounting and Reporting',
    quickTip: '(I want to conduct routine GHG Inventory Accounting and Reporting for Acquired Data)',
    complianceTip: '(I want to get a comprehensive GHG Inventory Accounting and Report)',
    inventoryWay: 'GHG Inventory Accounting Method',
    name: 'Task Name',
    subordinate: 'Subordinate task name',
    projectName: 'Project Name',
    main: 'Reporting company',
    progress: 'Accounting Progress',
    period: 'GHG Inventory Reporting Period',
    startTime: 'Start Time',
    endTime: 'End Time',
    objectName: 'Reporting Company Name',
    organizationalBoundary: 'Organizational Boundary',
    operatingBoundary: 'Operating Boundary',
    timeStart: 'Issued Date',
    tips: 'Please enter content, e.g.,',
    tips1: 'Please enter content, e.g., Google',
    tips2: 'Please enter factory',
    export: 'Export Data',
    generate: 'Publish Report',
    previewReport: 'Preview Report',
    activeData: 'Activity Data',
    totalCarbon: 'Total Emissions',
    template: 'Report Template',
    reportName: 'Report Title',
    carbon: 'Emissions (tCO₂e)',
    greenProject: 'Greenhouse Gas Reduction Project',
    imProject: 'Significant Indirect Greenhouse Gas Emissions',
    reason: 'Reason',
    over: 'Cannot exceed 50 characters',
    radio1:
      'Equity Share Approach: Allocate greenhouse gas emissions and energy consumption responsibilities based on the equity share of operations.',
    radio2:
      'Operational Control Approach: If a company or its subsidiaries have full authority to propose and enforce operational policies for a business, the company has operational control over that business.',
    radio3:
      'Financial control Law: If a company has financial control over its business, then that company is able to directly influence its financial and operational policies and derive economic benefits from its activities.',
    closeTip: 'Closing windows directly will not save the modified content. Are you sure you want to close?',
    rangeTime: 'GHG Accounting Period',
    taskSource: 'Task Source',
    fillData: 'Fill Data',
    object: 'GHG Accounting Company',
    legalPerson: 'Issued Company',
    initiator: 'Initiator',
    inventoryReport: 'GHG Accounting Report',
    startFilling: '   Start Filling    ',
    continueFilling: 'Continue Filling',
    addTask: 'New Task',
    editTask: 'Edit Task',
    addProject: 'New',
    editProject: 'Edit Project',
    success: 'Successfully Created',
    viewReport: 'View Report',
    submitted: 'Submitted',
    notSubmitted: 'Not Submitted',
    checkTip1: 'Scope 2: Indirect Greenhouse Gas Emissions from the Use of fules and energy related activities',
    checkTip2: 'Scope 3: Indirect Greenhouse Gas Emissions from Transportation and Distribution',
    checkTip3: 'Scope 3: Indirect Greenhouse Gas Emissions from Purchased Goods and Services',
    checkTip4: 'Scope 3: Indirect Greenhouse Gas Emissions from the Use and End-of-Life Treatment of Sold Products',
    checkTip5: 'Scope 3: Other Unclassified Indirect Greenhouse Gas Emissions',
    checkTip6: 'Magnitude of Emissions',
    checkTip7: 'Ease and Accuracy of Data Acquisition',
    checkTip8: 'Complexity of Organization and Detection',
    checkTip9: 'Other Related Requirements',
    checkTip10: 'Other Criteria',
    PCarbonWay: 'Here are some options for GHG accounting',
    PTask: 'Task Name',
    PObject: 'Please enter the GHG inventory organization name',
    PTime: 'Please select the GHG inventory period',
    PProject: 'Please select the greenhouse gas reduction project',
    PIndirect: 'Please select significant indirect greenhouse gas emissions',
    PPurpose: 'Please enter the inventory purpose',
    PBoundary: 'Please select the organizational boundary',
    PReason: 'Please enter the reason',
    PInput: 'Please enter',
    PReport: 'Please publish the report',
    PProjectName: 'Please select the project title',
    POrg: 'Please select the organization',
    PDelete: 'Please select the data to delete!',
    colon: '：',
    comma: '，',
    fullStop: '。',
    delete1: 'Are you sure to delete ',
    delete2: '?',
    checkTip11: 'Direct greenhouse gas emissions and removals',
    checkTip12: 'Indirect greenhouse gas emissions from energy',
    checkTip14: 'Fuel and energy-related activities (not included in Scope 1 and Scope 2)',
    checkTip15: 'Indirect greenhouse gas emissions from transportation',
    checkTip16: 'Indirect greenhouse gas emissions from organizational use of products or services',
    checkTip17: 'Indirect greenhouse gas emissions associated with product use',
    checkTip18: 'ther indirect greenhouse gas emissions not covered',
    beginTask: 'Start',
    inputProjectName: 'Please enter the project name.',
  },
  detail: {
    download: 'Download',
    purpose: 'Purpose of GHG reporting',
    orgBoundary: 'Organizational boundary',
    users: 'Intended reporting stakeholders',
    reportBoundary: 'Operational Boundary',
    reportOrg: 'Reporting company',
    reportStandard: 'Report standard',
    time: 'Time boundary',
    pass: 'Boundary compliance',
    basicMessage: 'I. Basic Information',
    emissionDistribution: 'II. Emission Overview',
    detailedList: 'III. Infomation on Emissions',
    dataSource: 'IV. Activity Data Sources',
    dataQuality: 'V. Data Quality Assurance',
    emissionFactor: 'VI. Emission Factor Data Sources',
    removalProject: 'VII. Greenhouse Gas Reduction Programs',
    qualityLevel: 'VIII. Quality Level',
    dataAttachment: 'IX. Activity Data Attachments',
    dataAttachment1: 'VIII. Activity Data Attachments',
    otherMessage: 'X. Other Relevant Information',
    otherMessage1: 'IX. Other Relevant Information',
    enterprise: 'Business Information',
    orgMessge: 'Oranizaiton Bodies and Regulatory Agencies',
    attachments: 'See Attachment 1',
    standard: 'Compliant with ISO 14064 Standard',
    dataVerification: 'Data verified internally',
    totalEmission: 'Total Emissions (tCO₂e)',
    rangeTotal1: 'Scope 1 Emissions',
    rangeTotal2: 'Scope 2 Emissions',
    rangeTotal3: 'Scope 3 Emissions',
    biomass: 'Biomass Combustion',
    gradeTip1:
      'Assessment method: Calculate the average value based on the classification of activity data, emission factor, and instrumental calibration, and then multiply it by the percentage of each GHG emission sources, and sum up to obtain the overall uncertainty score in the end.',
    gradeTip2:
      'Data is classified into five levels, and the higher the level, the better the data quality. The data quality score for this inventory is calculated as below:',
    gradeTip3: 'Grade is',
  },
  report: {
    greenType: 'Green Certificate Type',
    energyType: 'Energy Type',
    certName: 'Certificate Name',
    Pelectricity: 'Select Deduction of Purchased Electricity',
    automatic: 'Automatic calculation',
    actualUse: 'Actual Consumption',
    actualUnit: 'The Actual Unit',
    unitiveUse: 'Consumption After Unification',
    unitiveUnit: 'Unit After Unification',
    offsetInput: 'Fill in the emission source, factor version, region, green electricity consumption can be calculated',
    changeOld: 'Change to the historical version',
    nonGreen: 'Non-green Electricity Consumption',
    greenEle: 'Green Electricity Consumption',
    totalEle: 'Total Electricity Consumption',
    staging: 'Save as Draft',
    cooperation: 'Collaboration',
    upload: 'Upload Attachment',
    preview: 'preview',
    type: 'GHG Emission Source',
    type2: 'GHG Emission Source (English)',
    factorUnit: 'Emission Factor Unit',
    version: 'Emission Factor Version',
    carbon: 'Carbon Emissions (tCO₂e)',
    file: 'Attachment',
    region: 'Country/ Region',
    region1: 'BOD values in national/regional BOD domestic wastewater',
    industry: 'Industry',
    dischargeFacility: 'Emission Facility',
    activeData: 'Activity Data',
    activeDataInput: 'According to the total amount of waste water, COD automatic calculation',
    activeDataInput1: 'Based on the number of people, BOD area, IPCC default value, sewage treatment days',
    activeDataType: 'Activity Data Type',
    activeDataQuality: 'Activity Data Quality',
    calibrationLevel: 'Instrument Mantainance Level',
    number: 'Number of People',
    productType: 'Product Type',
    productVolume: 'Industrial product Volume',
    wasteWater: 'Wastewater quantity m³',
    inputOxygen: 'Chemical Oxygen Demand Concentration in Influent Wastewater',
    outputOxygen: 'Chemical Oxygen Demand Concentration in Effluent Wastewater',
    inputOxygenP: 'Concentration of chemical Oxygen Demand in imported anaerobic wastewater (mgCOD/L)',
    outputOxygenP: 'Chemical oxygen Demand Concentration in anaerobic outlet wastewater (mgCOD/L)',
    codInput:
      'Automatically calculated based on the chemical oxygen demand concentration in influent/effluent wastewater.',
    productName: 'Product Name',
    sludge: 'Mass of Sludge treatment(kg)',
    reclaimCH4: 'Mass of resues CH4 from water separated from sludge(kg)',
    hotWaterQuality: 'Mass of Hot Water',
    hotWaterTemperature: 'Temperature of Water',
    steamQuality: 'Mass of Steam',
    saturatedSteamQuality: 'Mass of Saturated Steam',
    press: 'Pressure',
    temperature: 'Temperature',
    factoryIndustry: 'Factory Industry',
    factoryType: 'Factory Type',
    area: 'Franchise’s area(㎡)',
    operatingArea: 'Total floor space(㎡)',
    rentalCategory: 'Asset Type',
    revenueAmount: 'Total Revenue',
    transportType: 'Vehicle Type',
    distributionType: 'Distribution Type',
    investmentType: "Investee's sector of Operation",
    investmentIndustry: 'Investment Industry',
    investmentAmount: 'Total Investment Revenue',
    materialType: 'Purchased Material Type',
    processingIndustry: 'Processing of Industry sector',
    processingAmount: 'Processing Amount',
    purchaseType: 'Purchased goods or Services Type',
    purchasingIndustry: 'Purchasing Industry',
    emissionType: 'GHG Emission Category',
    enterpriseProductType: 'Product Type',
    travelType: 'Transportation Category',
    weight: 'Weight (t) ',
    amount: 'Amount',
    expenditure: 'Waste Treatment Expenditure',
    wasteType: 'Waste-type',
    quantitySold: 'Quantities or units of goods (piece)',
    lifeExpectancy: 'Life Expectancy (months)',
    energyUsed: 'Total Consumed Energy per Product',
    energyUsed1: 'Consumed Energy per Product per Month',
    trialEnergy: 'Product Trial Energy',
    useEnergy: 'Consumed Energy',
    intendedUsed: 'Sit Product',
    name: 'Product Name',
    numberEmployees: 'Number of Employees (people)',
    carbonReduction: 'Carbon Reduction (t)',
    unit: 'Unit',
    wasteLatitude: 'Waste disposal and treatment Calculation Methods',
    spending: 'Spend-based（Bill）',
    quality: 'Waste-type-specific (t)',
    pSelect: 'Please Select Content',
    pInput: 'Please Enter Content',
    pInputWasteWater: 'Please enter the total wastewater volume',
    pNum: 'Please Enter Numbers Only',
    range1: 'Scope 1 Emissions',
    range2: 'Scope 2 Emissions',
    range3: 'Scope 3 Emissions',
    fixedCombustion: 'Stantionary Combustion Emissions',
    mobileCombustion: 'Mobile Combustion Emissions',
    processEmissions: 'Process Emissions',
    fugitiveEmissions: 'Fugitive Emissions',
    fugitiveEmissions1: 'Fugitive Emissions - Domestic Wastewater',
    fugitiveEmissions2: 'Fugitive Emissions - Industrial Wastewater',
    fugitiveEmissions3: 'Fugitive Emissions - Cooling, extinguisher',
    electricity: 'Purchased Electricity',
    heat: 'Purchased Heating',
    hotWater: 'Purchased Hot Water',
    heatSteam: 'Purchased Superheated Steam',
    saturatedSteam: 'Purchased Saturated Steam',
    greenElectricity: 'Green Electricity',
    nonGreenElectricity: 'Non-Green Electricity',
    solarEnergy: 'Self-Built Photovoltaic',
    greenCertificates: 'Purchased Green Certificates',
    offsetEmission: 'Offset Emission (tCO₂e)',
    employeeCommuting: 'Employee Commuting',
    tradeCaravan: 'Business Travel',
    upstreamLeased: 'Upstream Leased Assets',
    downstreamLeased: 'Downstream Leased Assets',
    thirdPartyTransportation: 'Third-Party Transportation',
    upstreamAndDownstream: 'Upstream and Downstream Distribution',
    wasteOperations: 'Waste Generated in Operations',
    processingProducts: 'Processing of Sold Products',
    useProducts: 'Use of Sold Products',
    soldProducts: 'End-of-Life Treatment of Sold Products',
    franchising: 'Franchises',
    productsAndServices: 'Purchased Goods and Services',
    investment: 'Investments',
    biomassCombustion: 'Biomass Emissions',
    otherGreenhouseGases: 'Another Greenhouse Gas Emissions Data',
    greenhouseGasRemoval: 'Greenhouse Gas Reduction Projects',
    tip1: "Organization's operations involve combustion of fuels in fixed equipment, such as boilers, furnaces, turbines, heaters, incinerators, engines, and combustion towers.",
    tip2: "Organization's operations include the consumption of fuels in owned or leased transportation equipment operated by the organization (e.g., motor vehicles, trucks, ships, airplanes, locomotives, forklifts), excluding transportation in the upstream and downstream.",
    tip3: 'Physical and chemical process operations in organizational operations result in the emission of greenhouse gases, including but not limited to carbon dioxide emissions from the calcination process in cement production, carbon dioxide emissions from catalytic cracking in petrochemical processes, and perfluorocarbon emissions from aluminum refining.',
    tip41: "Treatment of domestic wastewater in the organization's operations",
    tip42: "Treatment of industrial wastewater in the organization's operations",
    tip43: "Treatment of refrigeration in the organization's operations",
    tip5: 'Electricity purchased by the organization',
    tip6: "Heat purchased by the organization (fill in activity data in 'GJ')",
    tip7: "Hot water purchased by the organization (fill in the activity data in units of 't' or 'L' and then convert it to 'GJ' for calculation)",
    tip8: "Superheated steam purchased by the organization (fill in the activity data in units of 't' or 'L' and then convert it to 'GJ' for calculation)",
    tip9: 'Saturated steam purchased by the organization',
    tip10: 'Green electricity purchased by the organization',
    tip11: 'Solar energy purchased by the organization',
    tip12:
      'It is assumed that the sewage treatment of the plant is determined according to the inventory time period, other values are default to IPCC default values, MCF defaults to anaerobic reactor (0.5), and sewage treatment system without CH4 recovery system and sludge removal.',
    tip13:
      'Assuming that the maximum CH4 production capacity of Bo is 0.25kgCH4/COD, there is no CH4 recovery system and sewage treatment system for sludge removal',
    tip14: 'Green certificates purchased by the organization to offset carbon emissions in Scope 2',
    totalCarbon: 'Total Emissions',
    have: 'Yes',
    not: 'No',
    fileName: 'Attachment name',
    electricQuantity: 'Electric quantity (kWh)',
    emissionReduction: 'Emission reduction',
    onlyPDF: 'The size of the attachment is limited to 50M',
    unitCalculator: 'Unit Calculator',
    beforeConversion: 'Before conversion',
    conversionRatio: 'conversion factor',
    afterConversion: 'After conversion',
    ISOMessage1: 'Direct greenhouse gas emissions (category 1)',
    ISOMessage2: 'Greenhouse gas emissions from fossil fuel combustion',
    ISOMessage3: 'Biological, physical or chemical processes that produce greenhouse gas emissions',
    ISOMessage4: 'Controlled transportation of raw materials, products, waste and employee transportation',
    ISOMessage5: 'Sources of fugitive greenhouse gas emissions',
    ISOMessage6: 'Energy indirect greenhouse gas emissions (category 2)',
    ISOMessage7: 'Greenhouse gas emissions from purchased electricity, heat, steam or other fossil fuel derived energy',
    ISOMessage8: 'Indirect greenhouse gas emissions from transport (category 3)',
    ISOMessage9:
      'Indirect greenhouse gas emissions from transportation (e.g. employee business travel; transportation of products, raw materials or waste by third parties; employee commuting to and from the workplace)',
    ISOMessage10: 'Indirect greenhouse gas emissions from the use of products (Category 4)',
    ISOMessage11:
      'Indirect greenhouse gas emissions from the use of products (e.g. foreign aid activities, outsourced manufacturing and authorized dealers; emissions included in non-energy raw materials)',
    ISOMessage12: 'Indirect greenhouse gas emissions from products (category 5)',
    ISOMessage13:
      'Indirect GHG emissions from products (i.e., emissions from the use and end-of-life phases of products and services generated by the facility; when GHG emissions occur from sources or facilities outside the facility boundary, emissions come from waste generated by the facility)',
    ISOMessage14: 'Other indirect greenhouse gas emissions (category 6)',
    ISOMessage15: 'Greenhouse gas emissions from other sources (not included in the above 5 categories)',
    carbonUnit: 'Emissions (tCO₂ e )',
    percentage: 'percentage',
    ISOTable2Message1: 'Category 1 emissions',
    ISOTable2Message2: 'Category 2 emissions',
    ISOTable2Message3: 'Category 3 emissions',
    ISOTable2Message4: 'Category 4 emissions',
    ISOTable2Message5: 'Category 5 emissions',
    ISOTable2Message6: 'Category 6 emissions',
    ISOTable2Message7: 'Direct greenhouse gas emissions',
    ISOTable2Message8: 'Indirect energy emissions',
    ISOTable2Message9: 'Indirect greenhouse gas emissions from transport',
    ISOTable2Message10: 'Indirect greenhouse gas emissions from product use',
    ISOTable2Message11: 'Indirect greenhouse gas emissions from products',
    ISOTable2Message12: 'Other indirect greenhouse gas emissions',
    ISOTable2Message13: 'Total emissions of various greenhouse gases',
    ISOTable2Message14: 'Percentage of various greenhouse gases',
    summary: 'Summary',
    ISOMessage16: 'Weighted average score data level',
    ISOMessage17: 'Weighted average integral data',
    activeDataRank: 'Active data rank',
    carbonEmissionRank: 'Emission coefficient level',
    calibrationRank: 'Instrument calibration level',
    avgScore: 'Average score',
    rank: 'Data level',
    carbonEmissionRate: 'Emission ratio',
    weightedAvgScore: 'weighted average score',
    total: 'Total',
    ratio: 'ratio',
    information: 'Instructions',
    type1: 'Category 1',
    type2: 'Category 2',
    type3: 'Category three',
    type4: 'Category 4',
    type5: 'Category 5',
    type6: 'Category six',
    ghg: 'GHG Report Template',
    ghgReport: 'GHG Report',
    iso: 'ISO14064 template',
    isoReport: 'ISO14064 report',
    reportNo: 'Report number',
    isoTitle1: 'I. Organization Overview',
    isoTitle2: 'II. Organizational Boundaries',
    isoTitle3: 'Three, Operational Boundaries',
    isoTitle4: 'IV. Quantification of greenhouse gases',
    companyName: 'Company Name',
    companyNamePlaceholder: 'Please enter the company name',
    companyAddress: 'Company Address',
    companyAddressPlaceholder: 'Please enter the company address',
    businessScope: 'Business Scope',
    businessScopePlaceholder: 'Describe the business scope',
    businessActivity: 'Main production and operation activities or main products',
    greenhouseGasEmissionSources: 'Greenhouse gas emission sources',
    totalGreenhouseGasEmissions: 'Total greenhouse gas emissions',
    totalEmissionsOfGreenhouseGasCategories: 'Total greenhouse gas emissions',
    emissionFactorDataAndSources: 'Emission factor data and sources',
    dataQualityManagement: 'Data quality management',
    noDataTip: 'No page information yet',
    discharge0: 'Other',
    discharge1: 'boiler',
    discharge2: 'Painting equipment',
    discharge3: 'Generator',
    discharge4: 'heater',
    discharge5: 'waste gas combustion tower',
    discharge6: 'Gas stove (gas stove)',
    discharge7: 'burner',
    discharge8: 'Dryer',
    discharge9: 'Incinerator',
    discharge10: 'Oven (furnace)',
    discharge11: 'Diesel pump',
    discharge12: 'Constant temperature and humidity machine',
    discharge13: 'official car',
    discharge14: 'Truck',
    discharge15: 'Lawn mower (adjust from fixed combustion to mobile combustion)',
    discharge16: 'Forklift (Pusher)',
    discharge17: 'septic tank',
    discharge18: 'wastewater treatment',
    discharge19: 'CO2 fire extinguisher',
    discharge20: 'HFC-227ea fire extinguisher',
    discharge21: 'Air conditioning',
    discharge22: 'ice water machine',
    discharge23: 'Refrigerator',
    discharge24: 'Rust prevention/removal oil',
    discharge25: 'Production and office equipment and facilities',
    discharge26: 'Office equipment and facilities',
    discharge27: 'Heator',
    discharge28: 'Heating equipment',
    discharge29: 'Humidifier',
  },
  stage: {
    administrator: 'Administrator',
    normalUser: 'Common User',
    supervisor: 'Manager',
    pwd: 'Please enter the password',
    pwdonce: 'Please enter the password again',
    notSame: 'The password is different from the original password',
    tabTitle1: 'Organization Management',
    tabTitle2: 'User Management',
    tabTitle3: 'Emission Factor Settings',
    tabTitle4: 'Exchange Rate Settings',
    orgTree: 'Organization Tree',
    setRoot: 'Set Root Node:',
    orgName: 'Organization Name:',
    orgCode: 'Organization Code:',
    parentOrg: 'Parent Organization:',
    deleteSure: 'Are you sure you want to delete this data?',
    inputTip: 'Please enter content, e.g.,',
    operation: 'Operation',
    sort: 'Sort',
    organization: 'Your Organization',
    superiorDepartment: 'Superior Department',
    addOrg: 'Add Organization',
    editOrg: 'Edit Organization',
    userName: 'Username',
    jobNumber: 'Job Number',
    account: 'Name',
    email: 'Email',
    mobile: 'Mobile Number',
    password: 'Password',
    addUser: 'New Account',
    editUser: 'Edit Account',
    yourOrg: 'Your Organization',
    schedule: 'Default Exchange Rate Table',
    currency: 'Currency',
    rate: 'Exchange Rate to USD',
    dataSource: 'Data Source',
    updatedTime: 'Last Updated',
    addC: 'New Currency',
    editC: 'Edit Currency',
    fixedCombustion: 'Stantionary Combustion Emissions',
    mobileCombustion: 'Mobile Combustion Emissions',
    biomassCombustion: 'Biomass Combustion Emissions',
    foundational: 'Default Emission Factors',
    thirdParty: 'Third-Party Transportation and Distribution',
    basicTable: 'Default Emission Factors Table',
    userType: 'User Type',
    changePsd: 'Change password',
    newPsd: 'New password',
    newPsdC: 'New password confirmation',
    PInputC: 'Please enter your account',
    PPsd: 'Please enter the password',
    notNull1: 'The account can not be empty',
    notNull2: 'The password can not be empty',
    category1: 'Factor Classification 1',
    category2: 'Factor classification 2',
    emissionFactorUnit: 'Emission factor unit',
    emissionGasUnit: 'Emission factor gas unit',
    activeUnit: 'Activity data unit',
    factorEn: 'Factor name (English)',
    factorCode: 'Factor coding',
    country: 'country',
    countryEn: 'country (English)',
    sectoralEmissions: 'Sectoral emissions',
    energy: 'Energy sources',
    sOrg: 'Synchronous organization',
    sOrgS: 'Synchronization is successful',
    tableTip:
      'The factors used in the processing and investment of the products sold are the industry-wide emission factor table, and the factors used in the use of the products sold are the Range III - energy factor table.',
  },
  // Check template
  template: {
    newTemplate: 'New template',
    editTemplate: 'Edit template',
    templatePlaceholder: 'Please enter the template name',
    templateName: 'Template name',
    templateUsed: 'used',
    templateSelect: 'Select download template',
    templateSelectPlaceholder: 'Please select the template you want to download first',
    templateInclude: 'Template content includes',
    templateImport: 'There is already a template, click to import',
    templateDownloading: 'Downloading template......',
    importError: 'Failed to import data',
    importErrorNum: 'Number of data import failures:',
    importErrorReason: 'Failure reason:',
    importTitle: 'Data import',
  },
  // Foxconn Project
  honghai: {
    detail: 'Project details',
    approval: 'Approval details',
    history: 'Approval history',
    application: 'Project application approval process',
    acceptance: 'Project acceptance approval process',
    projectNumber: 'Project number',
    stepActive: 'Current progress',
    opinion: 'opinion',
    pass: 'Passed',
    reject: 'reject',
    jobNumber: 'job number',
    applicant: 'Applicant',
    originator: 'Originator',
    name: 'Name',
    contact: 'Contact information',
    mobile: 'Contact mobile phone',
    extension: 'extension',
    email: 'email',
    group: 'Business Group',
    selectgroup: 'Select business group',
    legalPerson: 'Legal person',
    selectlegalPerson: 'Select a legal person',
    park: 'park',
    selectpark: 'Select Park',
    createTime: 'Creation time',
    applyTime: 'Application time',
    greenenergyDescribe: 'Use green energy to describe the current situation and problems',
    pleaseEnter: 'Please enter',
    Energy_saving_system: 'Energy saving system',
    Energy_saving_method: 'Energy saving method',
    Energy_saving_object: 'Energy saving object',
    Energy_type: 'Energy type',
    Technical_sources: 'Technical sources',
    Principle: 'Energy saving principle',
    Annual_repair_cost: 'Annual repair cost',
    Annual_energy_efficiency: 'Annual energy saving benefits',
    Additional_benefits: 'Additional benefits',
    Total_benefits: 'Total benefits',
    Project_period: 'Project period',
    Project_benefit: 'Investment benefit',
    Basic_information: 'Basic information',
    Project_information: 'Project information',
    Benefit_information: 'Benefit information',
    title: 'Project List-Environmental Protection and Energy Saving Project System',
    search: 'Enter project name, project number, acceptance number ID',
    collapseFilter: 'Collapse filter',
    expandFilter: 'Expand filter',
    currentStep: 'Current review node',
    actualStartTime: 'Actual start time',
    actualEndTime: 'Actual end time',
    detailInfo: 'Approval information details',
    actualFinishTime: 'Actual completion time',
  },
  // Renewable energy usage
  renewableEnergy: {
    title: 'Renewable energy usage',
    AccEleConsumption: 'Accumulated power consumption',
    OverviewEleConsumption: 'Electricity consumption overview',
    eleAndRenew: 'Total of mains electricity and renewable energy',
    totalRenew: 'Total amount of renewable energy',
    totalEleFromOne: 'Statistics of the total amount from January to this month',
    replaceTarget: 'Replace target achievement progress',
    nonRenewable: 'Non-renewable resources',
    AccRenewablePercentage: 'Accumulated percentage of renewable energy',
    renewablePercentage: 'Renewable energy percentage',
    AnnualRenew: 'Annual total renewable energy use',
    yoy: 'year-on-year',
    monthOverview: 'Monthly electricity consumption overview',
    monthRenew: 'Total amount of renewable energy this month',
    monthRenew1: 'Statistics of this month',
    currentMonthRenew: 'Statistics of this month',
    monthConsumption: 'Monthly energy consumption',
    monthConsumptionOverview: 'Statistics of monthly electricity consumption',
    greenEnergy: 'Purchase green electricity',
    solarEnergy: 'Self-built photovoltaic',
    greenCertificate: 'Purchase Green Certificate',
    progress: 'Progress',
    proportion: 'proportion',
    nonGreen: 'Non-green electricity',
    externalPower: 'External power',
    renewable: 'renewable energy',
    AccConsumpt: 'Accumulated consumption of 10,000 kwh',
    AccConsumptYoy: 'Compared to last year',
    Consumpt: 'Consumption 10,000 kwh',
    nonRenew1: 'Non-renewable energy',
    Renew1: 'Renewable Energy Goals and Practices',
    Renew2: '2R monthly target',
  },
  //Reduce investment situation
  reduceInvestment: {
    title: 'Reduce investment situation',
    Reduce_Investment_Status: 'Reduce target and achievement status',
    Compare_With_Last_Year: "Comparison with last year's investment situation",
    Annual_unit_Project_Expenditure: 'Annual project expenditure of each unit',
    Energy_saving_system_investment_cost: 'Energy saving system investment cost table',
    energyTypePer: 'Energy type ratio',
    energySystemPer: 'Energy-saving system percentage',
    excel: 'Emission reduction cost project table',
    totalInvest: 'Total investment amount',
    totalBenefit: 'Total investment benefit',
    Annual_Project_Expenditure: 'Annual project expenditure',
    year: 'Year',
    org: 'Organization',
    investmentDetail: 'Energy-saving system investment details',
    mode: 'Statistical method',
    byCost: 'By investment cost',
    byNum: 'by project number',
    byEnergy: 'By energy saving',
    system: 'system',
    object: 'Energy saving object',
    count: 'Total number of projects',
    investmentAmount: 'Total investment amount',
    investbenefit: 'Investment benefit',
    projectReturn: 'Return on investment',
    energy: 'energy saving',
    cost: 'Investment cost',
  },
};
